import { render, staticRenderFns } from "./ApiReviewStep.vue?vue&type=template&id=51dc9bb5"
import script from "./ApiReviewStep.vue?vue&type=script&lang=js"
export * from "./ApiReviewStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports